(function () {
	// Antes esto usaba querySelector (singular) + new Swiper(".swiper-container", ...)
	// con un selector global: solo inicializaba el PRIMER swiper-container de
	// toda la pagina y, si se volvia a llamar, la comprobacion de
	// "slider_started" miraba tambien solo ese primero — nunca llegaba a
	// inicializar el resto de tarjetas, ni las que ya estaban en la pagina
	// de entrada mas alla de la primera, ni (el bug reportado) las que carga
	// el scroll infinito despues. Ahora recorre CADA swiper-container sin
	// inicializar todavia, uno a uno.
	const initSlider = () => {
		const sliders = document.querySelectorAll(".swiper-container:not(.slider_started)");
		sliders.forEach((sliderEl) => {
			// Los productos agotados se ocultan con display:none hasta que
			// termina de cargar toda la coleccion (ver
			// main-collection-product-grid.liquid, reorderAndToggleSoldOut).
			// Swiper no puede medir el ancho de un elemento oculto, asi que
			// inicializarlo ahora lo dejaria roto (0 slides detectados) para
			// siempre. Se deja SIN marcar como iniciado (offsetWidth sigue
			// siendo 0 mientras este oculto) para que, cuando se revele mas
			// adelante, la proxima llamada a esta misma funcion lo recoja e
			// inicialice correctamente.
			if (sliderEl.offsetWidth === 0) {
				return;
			}
			sliderEl.classList.add("slider_started");
			const swiper = new Swiper(sliderEl, {
				slidesPerView: 1,
				speed: 250,
				spaceBetween: 0,
				navigation: {
					nextEl: sliderEl.querySelector(".product-button-group .swiper-button-next-1"),
					prevEl: sliderEl.querySelector(".product-button-group .swiper-button-prev-1"),
				},
				pagination: {
					el: sliderEl.querySelector(".product-card-pagination"),
					clickable: true,
				},
			});

			const cardWrapper = swiper.el.closest(".card-wrapper");
			if (!cardWrapper || swiper.slides.length < 2) {
				return;
			}
			cardWrapper.addEventListener("mouseenter", () => swiper.slideTo(1));
			cardWrapper.addEventListener("mouseleave", () => swiper.slideTo(0));
		});
	};
	initSlider();
	document.addEventListener("shopify:section:load", initSlider);
	// El scroll infinito (assets/load-more.js) añade tarjetas nuevas al DOM
	// via AJAX despues de la carga inicial de la pagina; llama a esta misma
	// funcion (global, igual que ya hace con colorSwatches) para que esas
	// tarjetas nuevas tambien tengan el slider de hover funcionando.
	window.initProductCardSliders = initSlider;
})();
